import { updatesData } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm mt-2">平台运营动态与内容更新公告</p>
        </div>

        <div className="relative">
          <div className="absolute left-3 md:left-[19px] top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updatesData.map((item) => (
              <div key={item.id} className="relative pl-8 md:pl-12">
                <span
                  className={`absolute left-0 top-1 w-6 h-6 md:w-[38px] md:h-[38px] flex items-center justify-center rounded-full border-2 border-background-50 ${
                    item.tag === '重磅'
                      ? 'bg-primary-500 text-background-50'
                      : item.tag === '独家'
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-secondary-500 text-background-50'
                  } text-[10px] md:text-xs font-bold`}
                >
                  <i className="ri-flashlight-line"></i>
                </span>

                <div className="bg-background-100 rounded-xl p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span
                      className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                        item.tag === '重磅'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '独家'
                            ? 'bg-accent-100 text-accent-600'
                            : item.tag === '公告'
                              ? 'bg-foreground-100 text-foreground-600'
                              : 'bg-secondary-100 text-secondary-600'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}